export default theme => ({

  buttonIcon: {
    'marginRight': theme.spacing.unit
  },

  button: {
    'width': '100%',
    'justify-content': 'flex-start'
  }

});




// WEBPACK FOOTER //
// ./src/styles/components/Search.js